import { AppContext } from "@lightspeed-invoicing/core-client/frontend";
import React, { Component } from 'react';
import { FormattedNumber } from "react-intl";
import NumericLabel from "react-pretty-numbers";
import "./pagination.scss";

/**
 * Outdated version of the StatBox component used for legacy code support
 * See ./statbox.tsx for the updated component
 */
class StatBox extends Component {

    constructor(props, context) {
        super(props, context)
        this.state = {
            boxType: this.props.boxType || '',
            colorTextStyle: this.props.colorStyle || '',
            className: this.props.className || '',
            activeClassName: this.props.activeClassName || 'active-box',
            boxSelected: this.props.boxSelected || '',
            count: this.props.count || 0,
            amount: this.props.amount || 0,
            label: this.props.label || '',
            onChange: this.props.onChange || function () {
            },
        }
        this.handleStatClick = this.handleStatClick.bind(this)
    }

    componentWillReceiveProps(nextProps, nextContext) {
        this.setState({
            boxSelected: nextProps.boxSelected || '',
            count: nextProps.count || 0,
            amount: nextProps.amount || 0,
            label: nextProps.label || '',
        })
    }


    handleStatClick(event) {
        event.preventDefault()
        let boxSelected = this.state.boxType
        if (this.state.boxSelected === this.state.boxType) {
            boxSelected = ''
        }
        this.setState({
            boxSelected: boxSelected,
        }, () => {
            this.state.onChange(this.state.boxSelected)
        })
    }

    render() {
        let className = "click-stats-box " + this.state.className
        if (this.state.boxType === this.state.boxSelected && !this.props.isDashboard) {
            className += ' ' + this.state.activeClassName
        }
        let numberLabel = {
            justification: 'L',
            locales: AppContext.getLocale().getLanguage(),
            currency: true,
            currencyIndicator: AppContext.getCurrency(),
            percentage: false,
            precision: 0,
            commafy: false,
            shortFormat: true,
            title: true,
        }

        return <div className={this.props.isDashboard ? '' : "col-sm-12 col-md-3"}>
            <div className="row">
                <div className="py-1 col-12 flex">
                    <div className={className} onClick={this.handleStatClick} style={{ cursor: "pointer" }}>
                        <div className={(this.props.isDashboard && this.props.isEditable && "shortcut-filter") + " dashboard-stats-box"}>
                            <div className="dashboard-stats-desc text-center text-truncate ">
                                {this.props.children}
                                {this.state.label}
                                &nbsp;
                                (<FormattedNumber
                                    value={this.state.count}
                                />)
                            </div>
                            <div className={"dashboard-stat-value " + this.props.colorStyle}>
                                <h1 className="m-0 p-0">
                                    <NumericLabel params={numberLabel}>
                                        {this.state.amount}
                                    </NumericLabel>
                                </h1>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    }
}

export default StatBox





// WEBPACK FOOTER //
// ./src/common/listing/statbox.component.jsx